import { connect, ConnectedProps } from 'react-redux';

import { actions, selectors } from 'src/redux/data/auth/modules/slice';
import { RootState } from 'src/redux/store';

const mapStateToProps = (state: RootState) => ({
  forgotPasswordStatus: selectors.getForgotPasswordStatus(state),
});

const mapActionCreators = {
  forgotPassword: actions.forgotPassword,
  onForgotPasswordUnmount: actions.onForgotPasswordUnmount,
};

const Connector = connect(mapStateToProps, mapActionCreators);

export type PropsFromRedux = ConnectedProps<typeof Connector>;
export default Connector;
